import type { FirehoseMessageHandler } from '../firehose-message-router.js';

export const handlePreviewEnvironmentLogsViewerClose: FirehoseMessageHandler = (msg, deps) => {
  const environmentId = typeof msg.environmentId === 'string' ? msg.environmentId : '';
  const viewerId = typeof msg.viewerId === 'string' ? msg.viewerId : '';
  if (!environmentId || !viewerId) return;
  deps.previewEnvironmentManager.handleFirehoseLogViewerClose(environmentId, viewerId);
};
